import React from 'react';
import { connect } from 'react-redux';
import PageLayout from '../../components/common/PageLayout';
import Hero from '../../components/common/Hero';
import ReplenishProductsPermissionsContainer from '../blocks/ReplenishProductsPermissionsContainer';

function ReplenishProductsPageContainer(props) {
  const pageHero = props.reorder_image_link ? (
    <Hero backgroundImage={props.reorder_image_link} divStyle={{ minHeight: '15vw' }} />
  ) : (
    <Hero title="Reorder" />
  );

  return (
    <PageLayout top={pageHero}>
      <ReplenishProductsPermissionsContainer />
    </PageLayout>
  );
}

const mapStateToProps = (state) => {
  const { supplierId } = state.replenishProducts;
  const { retailerSuppliers } = state.role;

  const retailerSupplier = retailerSuppliers.find((retailerSupplier) => retailerSupplier.supplier.id === supplierId);

  if (retailerSupplier) {
    return {
      reorder_image_link: retailerSupplier.supplier.reorder_image_link,
    };
  }

  return {};
};

export default connect(mapStateToProps)(ReplenishProductsPageContainer);
